import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Pager from './pager';
import Image from '../i/icons_d.png';
import Blog4Icon from '../i/blog4.png';
import Blog5Icon from '../i/blog5.png';
import Blog6Icon from '../i/blog6.png';

const styles = {
  blogPostWrapper: {
    marginTop: 150,
    padding: '0 0 154px 0',
  },
  box: {
    width: '1112px',
    margin: 'auto',
  },
  landingHeading: {
    fontSize: '35px',
    fontWeight: '500',
    color: '#282828',
    textAlign: 'center',
    margin: 0,
    padding: '0 0 58px 0',
  },
  blogGrid: {
    position: 'relative',
  },
  bxWrapper: {
    maxWidth: '100%',
  },
  bxViewport: {
    width: '100%',
    overflow: 'hidden',
    position: 'relative',
    height: '452px',
  },
  bxSlider: {
    width: '100%',
    position: 'relative',
    transitionDuration: '0.2s',
    // transform: "translate3d(-1112px, 0px, 0px)",
    backgroundColor: 'white',
  },
  bxSliderList: {
    float: 'left',
    listStyle: 'none',
    position: 'relative',
  },
  gridBoxHolder: {
    backgroundColor: '#fff',
    borderRadius: '10px',
    width: '342px',
    margin: '0 42px 0 0',
    WebkitBoxShadow: '0px 0px 21px 0px rgba(0,0,0,0.09)',
    MozBoxShadow: '0px 0px 21px 0px rgba(0,0,0,0.09)',
    boxShadow: '0px 0px 21px 0px rgba(0,0,0,0.09)',
  },
  gridBoxHolderInner: {
    padding: '12px 13px 32px 13px',
  },
  gridBoxImage: {
    display: 'block',
    width: '314px',
    height: '157px',
    borderRadius: '10px',
    margin: '0 0 20px 0',
  },
  gridTxtBox: {
    padding: '0 15px',
  },
  blogTitle: {
    fontSize: '18px',
    color: '#282828',
    fontWeight: '500',
    lineHeight: '25px',
    display: 'table',
    textDecoration: 'none',
  },
  blogDescription: {
    fontSize: '13px',
    color: '#4f4f4f',
    lineHeight: '20px',
    margin: '13px 0 13px 0',
  },
  publishTxt: {
    fontSize: '13px',
    color: '#808080',
    float: 'left',
  },
  viewTxt: {
    margin: '0 26px 0 0',
    float: 'right',
  },
  viewIcon: {
    width: '14px',
    height: '9px',
    backgroundPosition: '-438px -107px',
    margin: '2px 4px 0 0',
    display: 'block',
    background: `url(${Image}) no-repeat`,
    backgroundSize: '750px 340px',
    float: 'left',
  },
  clearfix: {
    clear: 'both',
  },
  row: {
    display: 'flex',
  },
};

const posts = [
  {
    image: Blog4Icon,
    title: 'Title of the blog lorem ipsum goes here',
    description: `Description of the blog post oremlore loreui ipsum dolor sit amet, consectetur adipa dol
    scing elit, sed do eiusmod tempor inici lorid
    idunt ut labore et dolore magna aliaqua Uta enim ad minim veniam, quis nostruad exerai
    citation ullamco laboris nisi uloremt aliquipa ex ea comlor emipsum.`,
    publishedOn: '6 Jun ‘17',
    viewCount: 245,
  },
  {
    image: Blog5Icon,
    title: 'Title of the blog lorem ipsum goes here',
    description: `Description of the blog post oremlore loreui ipsum dolor sit amet, consectetur adipa dol
    scing elit, sed do eiusmod tempor inici lorid
    idunt ut labore et dolore magna aliaqua Uta enim ad minim veniam, quis nostruad exerai
    citation ullamco laboris nisi uloremt aliquipa ex ea comlor emipsum.`,
    publishedOn: '6 Jun ‘17',
    viewCount: 245,
  },
  {
    image: Blog6Icon,
    title: 'Title of the blog lorem ipsum goes here',
    description: `Description of the blog post oremlore loreui ipsum dolor sit amet, consectetur adipa dol
    scing elit, sed do eiusmod tempor inici lorid
    idunt ut labore et dolore magna aliaqua Uta enim ad minim veniam, quis nostruad exerai
    citation ullamco laboris nisi uloremt aliquipa ex ea comlor emipsum.`,
    publishedOn: '6 Jun ‘17',
    viewCount: 245,
  },
];

const BlogPosts = (props) => {
  const { classes } = props;
  return (
    <div className={classes.blogPostWrapper}>
      <div className={classes.box}>
        <h4 className={classes.landingHeading}>Read our latest Blog posts</h4>
        <div className={classes.blogGrid}>
          <div>
            <div className={classes.bxWrapper}>
              <div className={classes.bxViewport} aria-live="polite">
                <ul className={classes.bxSlider}>
                  <li aria-hidden="false" className={classes.bxSliderList}>
                    <div className={classes.row}>
                      {
                        posts.map(post => (
                          <div key={Math.random()} className={classes.gridBoxHolder}>
                            <div className={classes.gridBoxHolderInner}>
                              <img className={classes.gridBoxImage} src={post.image} alt="" />
                              <div className={classes.gridTxtBox}>
                                <span className={classes.blogTitle}>{post.title}</span>
                                <p className={classes.blogDescription}>
                                  {post.description}
                                </p>
                                <div>
                                  <p className={classes.publishTxt}>
                                    Published :
                                    <i>{post.publishedOn}</i>
                                  </p>
                                  <div className={classes.viewTxt}>
                                    <span className={classes.viewIcon} />
                                    <p className={classes.viewCount}>
                                      {post.viewCount}
                                      {' '}
                                      Views
                                    </p>
                                  </div>
                                  <div className={classes.clearfix} />
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      }
                      <div className={classes.clearfix} />
                    </div>
                  </li>
                </ul>
                <Pager />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withStyles(styles)(BlogPosts);

BlogPosts.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
};

BlogPosts.defaultProps = {
  classes: {},
};
